<template>
  <div class="company-intro">
    <!-- 公司简介 -->
    <div class="box-intro">
      <p class="box-title">关于天利</p>
      <div class="intro-content">
        <p>
          {{ mydata.company_profile.company_intro }}
        </p>
        <myXgplayer
          v-if="mydata.company_profile.company_intro_video"
          :width="mydata.video.width"
          :height="mydata.video.height"
          :url="completeUrl(mydata.company_profile.company_intro_video)"
        ></myXgplayer>

        <div v-else style="width: 343px; height: 201px"></div>
      </div>
    </div>

    <!-- 经营理念 -->
    <div class="box-Philosophy">
      <p class="box-title">经营理念</p>
      <div class="success-content1">
        <div
          class="flower"
          v-for="(item, index) in mydata.management_ideas"
          :key="index"
        >
          <div>
            <img v-complete:src="item.image" alt="" />
          </div>
          <p>{{ item.idea }}</p>
        </div>
      </div>
    </div>

    <!-- 公司成就 -->
    <div class="box-success">
      <p class="box-title">公司成就</p>
      <div class="success-content2">
        <companySuccessCards
          v-for="(item, index) in mydata.company_achievement"
          :key="index"
          :list="item"
        >
        </companySuccessCards>
      </div>
    </div>

    <!-- 公司文化 -->
    <div class="box-culture">
      <p class="box-title">公司文化</p>
      <div class="culture-content">
        <!-- <div
          class="content-left"
          v-for="(item, index) in mydata.company_culture.slice(0, 1)"
          :key="index"
        >
          <P>
            <span>“</span>
            {{ item.intro }}
            <span>”</span>
          </P>
          <p>
            <img
              src="@/assets/img/quill.png"
              style="
                width: 80px;
                margin-right: -20px;
                vertical-align: text-bottom;
              "
            />
            <span>{{ item.title }}</span>
          </p>
        </div> -->

        <div
          class="content-left"
          v-for="(item, index) in mydata.company_culture.slice(0, 1)"
          :key="index"
        >
          <template v-if="item.type === 1">
            <div class="in-box">
              <p>
                <img src="@/assets/左双引号.png" alt="" />
                {{ item.intro }}
                <img src="@/assets/右双引号 (1).png" alt="" />
              </p>
              <p>
                <span>{{ item.title }}</span>
                <img
                  src="@/assets/羽毛笔.png"
                  style="
                    width: 30px;

                    vertical-align: text-bottom;
                  "
                />
              </p>
            </div>
          </template>

          <img v-complete:src="item.image" alt="" v-else class="imgae-box" />
        </div>

        <div class="content-right">
          <div
            v-for="(item, index) in mydata.company_culture.slice(1, 4)"
            :key="index"
          >
            <p>{{ item.title }}</p>
            <p>
              {{ item.intro }}
              <!-- 成为全国优秀的基础教育纸质教辅与智慧教辅策划和发行机构。 -->
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- 公司荣誉 -->
    <div class="box-honor">
      <p class="box-title">公司荣誉</p>

      <!-- 轮播图图片组件 -->
      <swiperImg :dataArr="mydata.honor"></swiperImg>
    </div>
  </div>
</template>

<script setup>
import { completeUrl } from "@/utils/utils.js";
import swiperImg from "@/components/swiperImg/index.vue";
import { reactive, toRaw } from "vue";
import { ArrowLeft, ArrowRight } from "@element-plus/icons-vue";

import companySuccessCards from "@/components/companySuccessCards/index.vue";

import { useRouter, useRoute } from "vue-router";

//swiper start//////////////////////////////////////////////////////////////////////////////////////////////
// 引入swiper插件
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";
import {
  Autoplay,
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
} from "swiper/modules";

// 引入接口
import { companyIntro } from "@/api/walkIntroTianLi/companyIntroOne/index.js";

//视频
import myXgplayer from "@/components/myXgplayer/index.vue";

const router = useRouter();
const route = useRoute();

const mydata = reactive({
  // 图片数组
  imgArr: [
    {
      img: require("@/assets/Frame 2956.png"),
    },
    {
      img: require("@/assets/Frame 2956.png"),
    },
    {
      img: require("@/assets/Frame 2956.png"),
    },
    {
      img: require("@/assets/Frame 2956.png"),
    },
    {
      img: require("@/assets/Frame 2956.png"),
    },
    {
      img: require("@/assets/Frame 2956.png"),
    },
  ],

  //视频
  video: {
    width: "343px",
    height: "201px",
  },

  // 图片基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,

  // path: "",

  // companyIntroObj:{},//公司简介

  company_profile: [], //公司介绍配置
  management_ideas: [], //经营理念
  company_achievement: [], //公司成就
  company_culture: [], //公司文化
  honor: [], //公司荣誉
});
// import { reactive } from "@vue/reactivity";

// 如果一个页面有多次使用的话，注意这些变量名方法名再复制一份 start////////////////
// 创建功能模块
let modules = [Autoplay, Navigation, Pagination, Scrollbar, A11y];
//定义swiperNew,目的获取非响应式swiper
let swiperNew = null;
// 事件处理器
const onSwiper = (swiper) => {
  swiperNew = toRaw(swiper); //拿到swiper对象再转换为非响应式
};
//鼠标移入
const enter = () => {
  swiperNew.autoplay.stop();
};
//鼠标移出
const leave = () => {
  swiperNew.autoplay.start();
};
// 点击右箭头
const rightClick = () => {
  swiperNew.slidePrev();
};
// 点击左箭头
const leftClick = () => {
  swiperNew.slideNext();
};
// 单元块滑动
const onSlideChange = () => {};
// 如果一个页面有多次使用的话，注意这些变量名方法名再复制一份 end////////////////

//////////////////////////////////////////////////////////

// 获取公司简介
function companyIntroFn() {
  companyIntro({}).then((res) => {
    // console.log("公司简介", res.data);
    // mydata.companyIntroObj = res.data

    mydata.company_profile = res.data.company_profile; //公司介绍配置
    mydata.management_ideas = res.data.management_ideas; //经营理念
    mydata.company_achievement = res.data.company_achievement; //公司成就
    mydata.company_culture = res.data.company_culture; //公司文化
    // console.log(res.data.company_culture, "公司文化");
    mydata.honor = res.data.honor.map((item) => {
      item.img_url = mydata.VUE_APP_BASE_HOST + item.image;
      return item;
    }); //公司荣誉
    // console.log(mydata.company_profile.company_intro_video, "1111111111");
  });
}

// 调用函数
companyIntroFn();
</script>

<style scoped lang="scss">
.company-intro {
  // padding-bottom:40px;
  //标题
  .box-title {
    width: 343px;
    font-size: 18px;
    font-weight: 700;
    // line-height: 32px;
    color: #333333;
    margin: 0 auto;
    margin-top: 24px;
    margin-bottom: 16px;
  }
  // 公司简介
  .box-intro {
    width: 100%;
    // height: 357px;
    // border: 1px solid rgb(30, 255, 0);
    background-color: #ffffff;
    // background-color: pink;
    .box-title {
      margin-top: 16px;
      // margin-bottom: 0px;
    }
    .intro-content {
      width: 343px;
      // height: 245px;
      margin: 0 auto;
      // border: 1px solid rgb(43, 31, 212);
      // display: flex;
      // align-items: center;
      > p {
        text-indent: 2em;
        // width: 580px;
        // height: 220px;
        line-height: 24px;
        // line-height: 30px;
        // border: 1px solid blue;
        // margin-right: 30px;

        font-size: 14px;
        // font-size: 20px;
        font-weight: 400;
        color: #333333;
        // text-align: justify;

        // display: -webkit-box;
        // -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
        // text-overflow: ellipsis; //文本溢出 用省略号显示
        // -webkit-line-clamp: 10; //几行
        // overflow: hidden;
      }
      // > img {
      //   display: block;
      //   width: 590px;
      //   height: 245px;
      //   border:1px solid red;
      // }
    }
  }

  //经营理念
  .box-Philosophy {
    width: 100%;
    // border: 1px solid blue;
    background-color: #ffffff;
    .success-content1 {
      width: 343px;
      height: 111px;
      margin: 0 auto;
      background-color: #009de0;
      border-radius: 8px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .flower {
        width: 65px;
        height: 76px;
        // border:1px solid red;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        // margin-right: 77px;
        > div {
          width: 44px;
          height: 44px;
          background-color: #f7fbfc4d;
          border: 1px solid #a0e3ff;
          border-radius: 50%;
          padding: 5px;
          // display: flex;
          // align-items: center;
          // justify-content: center;
          img {
            width: 100%;
          }
        }

        p {
          font-size: 16px;
          font-weight: 700;
          color: #f9f9f9;
        }
      }

      // .box-flower4 {
      //   margin-right: 0px;
      // }
    }
  }

  // 公司成就
  .box-success {
    width: 100%;
    // border: 1px solid blue;
    background-color: #ffffff;
    // padding-bottom: 40px;
    .success-content2 {
      width: 343px;
      // height: 252px;
      margin: 0 auto;
      // border: 1px solid rgb(235, 23, 16);
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-content: space-between;
      .box-success {
        margin-bottom: 10px;
      }
    }
  }
  // 公司文化
  .box-culture {
    width: 100%;
    // height: 542px;
    // background-image: url("@/assets/Frame 2924.png");
    overflow: hidden;
    //标题
    .box-title {
      margin-top: 14px;
    }
    .culture-content {
      width: 343px;
      // height: 400px;
      margin: 0 auto;
      // border: 1px solid rgb(43, 31, 212);
      // display: flex;
      // justify-content: space-between;
      .content-left {
        // width: 578px;
        height: 235px;
        // height: 100%;
        border-radius: 8px;

        background-image: url("@/assets/a5377684-adc7-4380-9242-3a5b774a75ae (1).webp");
        background-position: center center;
        background-repeat: no-repeat;
        // background-attachment: fixed;
        background-size: cover;

        display: flex;
        justify-content: center;
        align-items: center;

        // position: relative;

        .in-box {
          width: 100%;
          height: 130px;
          // border-radius: 8px;
          background-color: #ffffff83;
          position: relative;
          // border: 1px solid red;

          p {
            // font-size: 32px;
            font-size: 14px;
            font-weight: 600;
            letter-spacing: 2px;
            // font-family: "pinrushouxieti";
            // font-style: oblique;

            // color: #f9f9f9;
            // border: 1px solid red;
            margin: 0 auto;
          }
          p:nth-of-type(1) {
            // width: 530px;
            width: 320px;
            // line-height: 24px;
            // margin-top: 100px;
            // border: 1px solid red;
            line-height: 28px;
            position: absolute;
            top: 45%;
            left: 50%;
            transform: translate(-50%, -50%);
            // > span {
            //   // width:20px !important;
            //   font-size: 40px;
            // }
            > img {
              width: 8px;
              height: 10px;
              margin-bottom: 5px;
            }
          }
          p:nth-of-type(2) {
            position: absolute;
            right: 10px;
            bottom: 10px;
            // border: 1px solid red;
          }
        }

        .imgae-box {
          width: 343px;
          // height: 400px;
          height: 100%;
          border-radius: 8px;
          // border: 1px solid rgb(0, 8, 255);
        }
      }
      .content-right {
        width: 343px;
        // height: 400px;
        // border: 1px solid red;
        margin-top: 16px;
        // display: flex;
        // flex-direction: column;
        // justify-content: space-between;
        > div {
          width: 343px;
          height: 120px;
          //   border: 1px solid rgb(157, 255, 0);
          border-radius: 8px;
          padding: 16px;
          margin-bottom: 10px;
          p:nth-of-type(1) {
            font-size: 18px;
            font-weight: 700;
            color: #333333;
            margin-bottom: 12px;
            // border: 1px solid red;
          }
          p:nth-of-type(2) {
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            line-height: 22px;

            display: -webkit-box;
            -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
            text-overflow: ellipsis; //文本溢出 用省略号显示
            -webkit-line-clamp: 2; //几行
            overflow: hidden;
          }
        }
        > div:nth-of-type(1) {
          background: linear-gradient(90deg, #ecf9fc 0%, #addfec 100%);
        }
        > div:nth-of-type(2) {
          background: linear-gradient(90deg, #f1fef7 0%, #b3e0c3 100%);
        }
        > div:nth-of-type(3) {
          background: linear-gradient(90deg, #d2e1ff 0%, #3170f0 100%);
          margin-bottom: 0px;
        }
      }
    }
  }
  // 公司荣誉
  .box-honor {
    width: 100%;
    // height: 452px;
    // border: 1px solid rgb(255, 81, 0);
    overflow: hidden;
    background-color: #ffffff;
    padding-bottom: 40px;
    // :deep(.book-cards) {
    //   display: flex !important;
    //   align-items: center !important;
    // }
    // :deep(.big-img) {
    //   height: 182px !important;
    // }

    :deep(.book-cards.column-book1) {
      // border:1px solid red;
      // width:170px;
      height: 180px !important;
      .bac-box {
        display: flex !important;
        align-items: center !important;
        //  width:277px;
        // background-color: transparent;
        .big-img {
          // width: 170px;
          height: 180px;
          display: block;

          // border:1px solid red;
        }
      }
    }
    :deep(.swiper-wrapper) {
      height: 180px;
      // height: 336px !important;
    }

    // :deep(.swiper-slide.book-cards){
    //   height:230px;
    //   // border:1px solid red;
    // }
    .l-btn {
      position: absolute;
      z-index: 9999;
      color: #333333;
      font-size: 20px;
      border: 1px solid #333333;
      width: 27px;
      height: 27px;
      border-radius: 100%;
      line-height: 27px;
      text-align: center;
      top: 45%;
      left: -80px;
      background: transparent;
    }

    .r-btn {
      position: absolute;
      z-index: 9999;
      color: #333333;
      font-size: 20px;
      border: 1px solid #333333;
      width: 27px;
      height: 27px;
      border-radius: 100%;
      line-height: 27px;
      text-align: center;
      top: 45%;
      right: -80px;
      background: transparent;
    }

    :deep(.r-btn[data-v-1891c10e]) {
      right: 0px;
    }

    :deep(.l-btn[data-v-1891c10e]) {
      left: 0px;
    }
    // .honor-content {
    //   width: 1200px;
    //   height: 310px;
    //   margin: 0 auto;
    //   // border: 1px solid rgb(0, 255, 8);
    //   position: relative;
    //   .honor-card {
    //     width: 281px;
    //     height: 310px;
    //     background-color: #cbcbcb;
    //     display: flex;
    //     justify-content: center;
    //     align-items: center;
    //     // border:1px solid red;
    //     > img {
    //       display: block;
    //       max-width: 281px;
    //       max-height: 310px;
    //     }
    //   }

    // }
  }
}
</style>
